import { render } from "./LbrxProductItem.vue?vue&type=template&id=6a59bf2e"
import script from "./LbrxProductItem.vue?vue&type=script&lang=js"
export * from "./LbrxProductItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__